"use client";

import { getCleanSpacing } from "@litonarefin/utils/spacing";
import React, { Fragment } from "react";

const Table = ({ attributes }) => {
  if (!attributes?.page_content || typeof attributes?.page_content !== "string") return null;
  
  return (
    <Fragment>
      <div
        className="jlt-table-wrapper"
        dangerouslySetInnerHTML={{ __html: attributes.page_content || "" }}
      />
      <style jsx>{`
        .jlt-table-wrapper {
          overflow-x: auto;
          table,
          td,
          th {
            border: ${`${attributes?.style?.border?.width ? attributes?.style?.border?.width : "1px"} ${attributes?.style?.border?.style ? attributes?.style?.border?.style : "solid"} ${attributes?.style?.border?.color ? attributes?.style?.border?.color : "black"}`};
            padding: 10px;
            ${attributes?.style?.typography?.fontSize ? `font-size: ${attributes?.style?.typography?.fontSize}` : ""}
          }
          table {
            border-collapse: collapse;
          }

          ${getCleanSpacing(attributes?.style?.spacing?.margin?.top)
            ? `margin-top: ${getCleanSpacing(attributes?.style?.spacing?.margin?.top)}!important;`
            : ""}
          ${getCleanSpacing(attributes?.style?.spacing?.margin?.bottom)
            ? `margin-bottom: ${getCleanSpacing(attributes?.style?.spacing?.margin?.bottom)};`
            : ""}
          ${getCleanSpacing(attributes?.style?.spacing?.padding?.top)
          ? `padding-top: ${getCleanSpacing(attributes?.style?.spacing?.padding?.top)};`
          : ""}
                      
          ${getCleanSpacing(attributes?.style?.spacing?.padding?.bottom)
          ? `padding-bottom: ${getCleanSpacing(attributes?.style?.spacing?.padding?.bottom)};`
          : ""}
          ${getCleanSpacing(attributes?.style?.spacing?.padding?.left)
          ? `padding-left: ${getCleanSpacing(attributes?.style?.spacing?.padding?.left)};`
          : ""}
          ${getCleanSpacing(attributes?.style?.spacing?.padding?.right)
          ? `padding-right: ${getCleanSpacing(attributes?.style?.spacing?.padding?.right)};`
          : ""}
        }
      `}</style>
    </Fragment>
  );
};

export default Table;
